<template>
  <Marker :options="options" @click="onClick">
    <InfoWindow ref="infoWindowRef" :options="infoWindowOptions" v-if="renderInfoWindow">
      <EcoEventsStopInfo :address="address" :duration="duration" :time="time" />
    </InfoWindow>
  </Marker>
</template>

<script>
import {InfoWindow, Marker} from "vue3-google-map";
import {entityDataManager, GoogleMapsManager} from "@/assets/js/data-manipulation";
import EcoEventsStopInfo from "@/components/pages/EcoEventsStopInfo.vue";
import {mapGetters} from "vuex";
import yellowMarkerImage from "@/assets/images/reports/yellow-marker.png";
import greenMarkerImage from "@/assets/images/reports/green-marker.png";
import redMarkerImage from "@/assets/images/reports/red-marker.png";

export default {
  name: "StopMarker",
  components: {EcoEventsStopInfo, InfoWindow, Marker},
  props: {
    stopData: {
      type: Object,
      required: true
    },
    infoWindowHeader: {
      type: Object,
      required: true
    },
    openInfoOnClick: {
      type: Boolean,
      default: true
    },
    colorVariant: {
      type: String,
      default: undefined,
      validator(value) {
        return value === undefined || ['green', 'yellow', 'red'].includes(value);
      }
    },
    customOptions: Object,
  },
  emits: ['click'],
  data() {
    return {
      renderInfoWindow: false
    };
  },
  computed: {
    ...mapGetters(['userId']),
    options() {

      let showStopIndex = true;
      let icon = undefined;
      switch (this.colorVariant) {
        case 'green':
          showStopIndex = false;
          icon = {
            url: greenMarkerImage,
            scaledSize: new window.google.maps.Size(38, 38)
          }
          break;
        case 'yellow':
          showStopIndex = false;
          icon = {
            url: yellowMarkerImage,
            scaledSize: new window.google.maps.Size(38, 38)
          }
          break;
        case 'red':
          showStopIndex = false;
          icon = {
            url: redMarkerImage,
            scaledSize: new window.google.maps.Size(38, 38)
          }
          break;
      }

      return {
        ...{
          position: this.position,
          label: showStopIndex ? `${this.stopData?.index ?? ''}` : '',
          icon
        },
        ...this.customOptions
      };
    },
    /*pinOptions() {
      return {
        glyph: markerIcon
      };
    },*/
    infoWindowOptions() {
      return {
        position: this.position,
        headerContent: this.infoWindowHeader
      };
    },
    position() {
      return GoogleMapsManager.getGoogleGeoByReportStop(this.stopData);
    },
    address() {
      return entityDataManager.getAddressByReportStop(this.stopData);
    },
    time() {
      const data = entityDataManager.getTimeByReportStop(this.stopData);
      return data !== null ? data.format(this.$t('settings.generic.date-time-format-moment')) : ''
    },
    duration() {
      const data = entityDataManager.getDurationByReportStop(this.stopData);
      return data !== null ? data : ''
    }
  },
  methods: {
    onClick() {
      this.$emit('click', this);
      if (this.openInfoOnClick) {
        this.showInfoWindow();
      }
    },
    showInfoWindow() {
      this.renderInfoWindow = true;
      setTimeout(() => this.$refs.infoWindowRef?.open(), 10);
    },
    closeInfoWindow() {
      this.$refs.infoWindowRef?.close();
      this.renderInfoWindow = false;
    },
    isInfoWindowOpen() {
      return this.$refs.infoWindowRef?.infoWindow.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
